import { useState } from 'react';
import { Loader2, ShieldAlert } from 'lucide-react';
import { useUser } from '../../contexts/UserContext';
import { GeneratedGiftcard } from '../../interfaces/giftcard.interface';
import GiftcardForm from './components/GiftcardForm';
import GiftcardResult from './components/GiftcardResult';
import GiftcardHistory from './components/GiftcardHistory';

const GiftcardsPage = () => {
  const { user, loading } = useUser();
  const [giftcard, setGiftcard] = useState<GeneratedGiftcard | null>(null);
  const [emailRequested, setEmailRequested] = useState(false);
  const [refreshToken, setRefreshToken] = useState(0);

  const handleCreated = (
    created: GeneratedGiftcard,
    withEmail: boolean
  ): void => {
    setGiftcard(created);
    setEmailRequested(withEmail);
    setRefreshToken((token) => token + 1);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center gap-2 py-20 text-gray-500">
        <Loader2 size={18} className="animate-spin" />
        Chargement...
      </div>
    );
  }

  // La function refuse déjà les non-admins : ce garde-fou évite juste
  // de présenter un formulaire qui ne pourrait pas aboutir.
  if (user?.role !== 'admin') {
    return (
      <div className="mx-auto mt-10 max-w-lg rounded-2xl border border-amber-200 bg-amber-50 p-6 text-center">
        <ShieldAlert size={32} className="mx-auto mb-3 text-amber-600" />
        <h2 className="text-lg font-semibold text-amber-900">
          Accès réservé aux administrateurs
        </h2>
        <p className="mt-2 text-sm text-amber-800">
          L'émission de bons cadeaux crée de la valeur : elle est réservée aux
          comptes ayant le rôle <code className="font-mono">admin</code>.
          Votre compte a le rôle{' '}
          <code className="font-mono">{user?.role ?? 'inconnu'}</code>.
        </p>
      </div>
    );
  }

  return (
    <div className="p-2 space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-[#623413]">Bons cadeaux</h1>
        <p className="mt-1 text-sm text-gray-600">
          Générer un bon réglé en boutique, sans passer par le paiement en
          ligne. Le bon est immédiatement utilisable sur le site avec son code.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <GiftcardForm onCreated={handleCreated} />
        <GiftcardResult giftcard={giftcard} emailRequested={emailRequested} />
      </div>

      <GiftcardHistory refreshToken={refreshToken} />
    </div>
  );
};

export default GiftcardsPage;
